jQuery(document).ready(function ($) {
  var $accordionHeader = $('.js-accordion-header');
  var $accordionBody = $('.js-accordion-body');
  var $accordionButton = $('.js-accordion-button');

  $accordionHeader
    .once()
    .on('click', function () {
      var $this = $(this);
      var $accordionContent = $this.next($accordionBody);
      var isExpanded = $this.attr('aria-expanded') === 'true';
      var $currentAccordionButton = $this.find($accordionButton);

      $accordionContent.slideToggle();
      $this.attr('aria-expanded', !isExpanded);
      $accordionContent.attr('aria-hidden', isExpanded);

      $currentAccordionButton.toggleClass('open', !isExpanded);

      $accordionBody.not($accordionContent).slideUp().attr('aria-hidden', 'true');
      $accordionHeader.not($this).attr('aria-expanded', 'false');
      $($accordionButton).not($currentAccordionButton).removeClass('open');
    })
    .on('keydown', function (e) {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        $(this).click();
      }
    });
});
